import { render, staticRenderFns } from "./QRPage.vue?vue&type=template&id=58d25578&scoped=true"
import script from "./QRPage.vue?vue&type=script&lang=ts"
export * from "./QRPage.vue?vue&type=script&lang=ts"
import style0 from "./QRPage.vue?vue&type=style&index=0&id=58d25578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d25578",
  null
  
)

export default component.exports